import { mergeSharedTranslations } from "@shared/utils/mergeSharedTranslations";

import { account } from "./account";
import { accountSettings } from "./accountSettings";
import { analyticsDashboard } from "./analyticsDashboard";
import { attachments } from "./attachments";
import { careCenter } from "./careCenter";
import { catalog } from "./catalog";
import { clinicCommon } from "./clinicCommon";
import { favorites } from "./favorites";
import { integrations } from "./integrations";
import { libraries } from "./libraries";
import { migrations } from "./migrations";
import { navigation } from "./navigation";
import { newSideNav } from "./newSideNav";
import { notificationHub } from "./notificationHub";
import { onSite } from "./onSite";
import { onboarding } from "./onboarding";
import { patientDetails } from "./patientDetails";
import { patientImport } from "./patientImport";
import { patientSearch } from "./patientSearch";
import { patientSmartPlanBuilder } from "./patientSmartBuilder";
import { patientsOrders } from "./patientsOrders";
import { plansPage } from "./plansPage";
import { policies } from "./policies";
import { practitionerHub } from "./practitionerHub";
import { protocols } from "./protocols";
import { referrals } from "./referrals";
import { reports } from "./reports";
import { rupaMigration } from "./rupaMigration";
import { staffSettings } from "./staffSettings";
import { storeInsights } from "./storeInsights";
import { storeSettings } from "./storeSettings";
import { supportMenu } from "./supportMenu";
import { treatmentPlanTool } from "./treatmentPlanTool";
import { whatsNew } from "./whatsNew";
import { wholesaleOrders } from "./wholesaleOrders";

/*
Must also export within the correct SPA to be loaded properly
E.g. clinic/fullscript/practitioner/locales, clinic/fullscript/clerk/locales
*/
export const US = mergeSharedTranslations({
  accountSettings,
  analyticsDashboard,
  attachments,
  catalog,
  common: clinicCommon,
  favorites,
  integrations,
  libraries,
  navigation,
  newSideNav,
  onboarding,
  onSite,
  patientDetails,
  patientImport,
  patientSearch,
  patientSmartPlanBuilder,
  patientsOrders,
  plansPage,
  policies,
  practitionerHub,
  protocols,
  referrals,
  rupaMigration,
  supportMenu,
  staffSettings,
  storeInsights,
  storeSettings,
  wholesaleOrders,
  whatsNew,
  migrations,
  treatmentPlanTool,
  reports,
  careCenter,
  account,
  notificationHub,
});
